import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { Cell } from '../../../DataStructures/TableModel/Cell';
import { Moment } from 'moment';
import { Area } from '../../../DataStructures/Area/Area';
import { UserService } from '../../../services/user-service/user.service';
import { QuickDialog } from '../../../utilities/Dialog/QuickDialog';;
import * as moment from 'moment';
import { DateConstants } from '../../../utilities/WeekSchedule/DateConstants';
import { MainService } from '../../../services/optimizer-service/optimizer.service';
import { Trip } from '../../../DataStructures/Trip/Trip';
import { MapquestService } from '../../../services/map-quest/mapquest.service';
import { TimeSlotForDay } from '../../../DataStructures/TimeSlotRow/TimeSlotRow';
import { TimeSlotTableComponent } from '../time-slot-table/time-slot-table.component';
declare var google: any;

@Component({
  selector: 'app-time-slot-editor-dialog',
  templateUrl: './time-slot-editor-dialog.component.html',
  styleUrls: ['./time-slot-editor-dialog.component.css']
})
export class TimeSlotEditorDialogComponent implements OnInit {
  slotForDay: TimeSlotForDay;
  timeSlotTable: TimeSlotTableComponent;
  addMode = false;
  users: Array<any>;
  areas: Array<Area>;
  filterList: Array<any>;
  areaFilterList: Array<Area>;
  checkedAreas: Array<Area> = [];
  checkedUsers: Array<any> = [];
  companyid;
  locationid;
  pickupType;

  constructor(private userService: UserService, private dialog: MatDialog, public dialogRef: MatDialogRef<TimeSlotEditorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private optimizer: MainService, private mapquest: MapquestService) {
    this.slotForDay = data.slotForDay;
    this.timeSlotTable = data.timeSlotTable;
    this.areas = this.slotForDay.areas;
    this.areaFilterList = this.areas;
    this.companyid = data.companyid;
    this.locationid = data.locationid;
    this.pickupType = data.pickupType;
  }

  ngOnInit(): void {
  }

  getHeading() {
    return this.slotForDay.timeSlotRef.fullDate.format(DateConstants.localizedStandard);
  }

  checked(value, area) {

    if (value) {
      this.checkedAreas.push(area);
    } else {
      this.checkedAreas.splice(this.checkedAreas.indexOf(area), 1);
    }
  }

  checkAll() {
    this.uncheckAll();
    this.areaFilterList.forEach(a => {
      this.checkedAreas.push(a);
    });
    this.toggleCheckboxes(true);
  }


  uncheckAll() {
    this.checkedAreas = [];
    this.toggleCheckboxes(false);
  }

  removeAllChecked() {

    if (this.checkedAreas.length == 0) {
      new QuickDialog(this.dialog).InfoDialog("You did not select any users", "No Users Selected", "OK");
      return;
    }

    new QuickDialog(this.dialog).
      DecisionDialog({
        message: `Are you sure you want to remove ${this.checkedAreas.length} users?`, options: [
          {
            icon: 'fa-thumbs-up',
            code: 'yes',
            message: "Yes"
          },
          {
            icon: 'fa-ban',
            code: 'no',
            message: 'Cancel'
          }
        ]
      }).then((choice) => {
        if (choice == 'yes') {
          var d = new QuickDialog(this.dialog).LoadingDialog("Removing users....");
          this.userService.deletePickupByIds(this.checkedAreas.map(a => a.pickupid)).then((res: any) => {
            d.close();
            if (res.status) {
              this.timeSlotTable.reload();
            } else {
              new QuickDialog(this.dialog).InfoDialog(res.message, "Could Not Remove Users", "OK");
            }

          }).catch(e => {
            d.close();
            new QuickDialog(this.dialog).InfoDialog(e, "Could Not Remove Users", "OK");
          })
          this.dialogRef.close();
        }
      });
  }

  moveAllChecked() {
    if (this.checkedAreas.length == 0) {
      new QuickDialog(this.dialog).InfoDialog("You did not select any users", "No Users Selected", "OK");
      return;
    }
    this.timeSlotTable.enterEditorModeForMove({
      areas: this.checkedAreas,
      cell: this.slotForDay
    });
    this.dialogRef.close();
  }


  toggleCheckboxes(state: boolean) {
    let checkboxes: any = document.getElementsByClassName('mCheckbox');
    for (var i = 0, n = checkboxes.length; i < n; i++) {
      checkboxes[i].checked = state;
    }
  }

  shouldCheckUser(cbox, user) {
    var u = this.checkedUsers.find(x => x.userid == user.userid);
    if (u) {
      return true;
    } else {
      return false;
    }
  }

  enterAddMode() {
    this.addMode = true;
    var d = new QuickDialog(this.dialog).LoadingDialog("Loading Users...");
    this.userService.getUserByCompany(this.companyid).then((res: any) => {

      d.close();

      if (res.status) {

        this.users = res.data;
        var areas: Array<Area> = this.slotForDay.areas;
        this.users = this.users.filter(u => areas.find(a => a.userid == u.userid) == null);
        this.filterList = this.users;
      } else {
        new QuickDialog(this.dialog).InfoDialog(res.message, "", "Ok");
      }
    }).catch(e => {
      d.close();
      new QuickDialog(this.dialog).InfoDialog(e, "", "Ok");
    })
  }

  addUsers() {
    var pickupdata = [];
    this.checkedUsers.forEach(u => {
      var data = {
        "EmployeeID": u.employeeid,
        "LocationCode": this.locationid,
        "DepartmentCode": u.departmentid,
        "PickupDate": this.slotForDay.timeSlotRef.fullDate.format(DateConstants.standardDateFormat),
        "PickupTime": this.slotForDay.timeSlotRef.fullDate.format(DateConstants.HourMinute12H)
      };
      pickupdata.push(data);
    });
    var d = new QuickDialog(this.dialog).LoadingDialog("Adding Users...");
    this.userService.batchPickupUpload(this.companyid, pickupdata,this.pickupType,false).then((res: any) => {
      d.close();
      this.timeSlotTable.reload();
      this.dialogRef.close();

    }).catch(e => {
      d.close();
      new QuickDialog(this.dialog).InfoDialog(e, "Error", "OK");
    })
    console.log(this.checkedUsers);
  }


  filterUsers(substring: string) {
    substring = substring.trim().toLowerCase();

    if (this.addMode) {
      if (substring.trim() == "") {
        this.filterList = this.users;
      } else {
        this.filterList = this.users.filter(x => (x.firstname.toLowerCase() + " " + x.lastname.toLowerCase()).includes(substring));
      }
    } else {
      if (substring.trim() == "") {
        this.areaFilterList = this.areas;
      } else {
        this.areaFilterList = this.areas.filter(x => x.destinations[0].person.toLowerCase().includes(substring));
      }
    }
  }

  userChecked(value, user) {
    if (value) {
      this.checkedUsers.push(user);
    } else {
      this.checkedUsers.splice(this.checkedUsers.indexOf(user), 1);
    }
  }

  /** View The Raw Passengers Marker On The Map */
  viewSet() {

  }


}



// WEBPACK FOOTER //
// ./src/app/admin-dashboard/optimizer/time-slot-editor-dialog/time-slot-editor-dialog.component.ts